function params(method, body, asFormData) {
  let header = {};
  if (body) {
    header = {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    };

    if (!asFormData) {
      header['Content-Type'] = 'application/json';
      body = JSON.stringify(body);
    }
    return { method: method, headers: header, body: body };
  } else {
    header = { Authorization: `Bearer ${localStorage.getItem('token')}` };
    return { method: method, headers: header };
  }
}

const projectSettingsService = {
  save: async (scriptId, settings) => {
    const request = `${process.env.REACT_APP_API_URL}/project/settings/${scriptId}`;

    const options = params('POST', {
      image_style: settings.image_style,
      image_orientation: settings.image_orientation,
      time_period: settings.time_period,
    });

    const response = await fetch(request, options);

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Failed to save project settings: ${response.status} ${text}`);
    }

    return response.json();
  },

  get: async (scriptId) => {
    const request = `${process.env.REACT_APP_API_URL}/project/settings/${scriptId}`;
    const options = params('GET');

    const response = await fetch(request, options);
    if (response.status === 404) {
      // No settings saved for this project yet -- expected for any project
      // that hasn't had the Project Settings modal used, not a failure.
      return null;
    }
    if (!response.ok) {
      throw new Error('Failed to load project settings');
    }

    return response.json();
  },
};

export default projectSettingsService;
